/* React */
import React from "react";

/* Ionic */
import { IonIcon } from "@ionic/react";
import { person } from "ionicons/icons";

/* Utils */
import { capitalizeFirstLetter } from "src/utils/helper/string-transformation";

/* Constants */
import { Insights } from "src/shared/constants/common/Common";

/* Stylesheet */
import styles from "./Cohort.module.scss";

/* Interfaces */
interface CohortProps {
  name?: string;
}

const Cohort: React.FC<CohortProps> = ({ name }) => {
  return (
    <div className={styles.cohort}>
      <div className={styles.name}>
        <IonIcon className={styles.icon} icon={person} />
        {name === null
          ? Insights.FULL_SAMPLE
          : capitalizeFirstLetter(name!)}
      </div>
    </div>
  );
};

export default Cohort;
